// extracted by mini-css-extract-plugin
export default {"root":"_3Ju_a","llama":"_2j55Z","big":"WGc8b","small":"CtV79"};